export enum TestimonialPrizeTypeEnum {
  SPECIAL = 'SPECIAL',
  INSTANT = 'INSTANT',
}

export const TestimonialPrizeTypeLabel: Record<TestimonialPrizeTypeEnum, string> = {
  [TestimonialPrizeTypeEnum.SPECIAL]: 'Sorteio especial',
  [TestimonialPrizeTypeEnum.INSTANT]: 'Prêmio instantâneo',
}

export enum TestimonialStatusEnum {
  ACTIVE = 'ACTIVE',
  HIDDEN = 'HIDDEN',
}
